import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ExternalAppService } from '../services/external-app.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PlatformAppMiddleware implements CanActivate {
  constructor(
    private router: Router,
    private externalAppService: ExternalAppService,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // check if is logged in
    if (this.authService.isLogged()) {
      this.externalAppService.check();
    }

    return true;
  }
}